"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onGlobalStateChange = exports.initGlobalState = void 0;
const initGlobalState = () => {
    return {
        actionType: undefined,
        isLoading: false,
        isScreenDataError: false,
        sessionData: {
            accessToken: undefined,
            refreshToken: undefined
        },
        account: JSON.parse(sessionStorage.getItem('account')) || {},
        secureInbox: {},
        helpDesk: {},
        compRedirect: {},
        userProfile: {
            currentObjectKey: ''
        },
        languageOptionList: []
    };
};
exports.initGlobalState = initGlobalState;
const onGlobalStateChange = state => { };
exports.onGlobalStateChange = onGlobalStateChange;
